var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.messagesCount > 0
    ? _c(
        "a",
        {
          staticClass: "action turquoise",
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.openMessages.apply(null, arguments)
            }
          }
        },
        [
          _c("Icon", { attrs: { icon: "mail" } }),
          _vm._v(" "),
          _vm.newMessagesCount > 0
            ? _c("span", { staticClass: "count-bubble" }, [
                _vm._v(_vm._s(_vm.newMessagesCount))
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }